const sortedTagsList = [
  "your rent include",
  "dual occupancy",
  "wi-fi",
  "wifi",
  "gyms",
  "gym",
  "fully furnished",
  "parking",
  "laundry",
  "secured premise",
  "common social area",
  "recycling",
  "swimming pool",
  "contents insurance",
  "reception staff",
  "kitchen",
  "double occupancy",
  "air conditioning",
  "storage",
  "guarantor requirement",
  "university distance",
  "fridge",
  "parcel collection",
  "breakfast bar",
  "coffee machine",
  "pet friendly",
  "no pets",
  "games room",
  "cinema room",
  "library",
  "lounge",
  "garbage disposal",
  "balcony/ terrace/ patio",
  "balcony",
  "terrace",
  "patio",
  "shuttle/ cab service",
  "shuttle",
  "cab service",
];
export default sortedTagsList;
